// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';

interface FormSkeletonProps {
  fields?: number;
  showHeader?: boolean;
  className?: string;
}

export function FormSkeleton({
  fields = 4,
  showHeader = true,
  className = '',
}: FormSkeletonProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      {showHeader && (
        <div className="space-y-2">
          <Skeleton className="h-7 w-40" />
          <Skeleton className="h-4 w-full max-w-md" />
        </div>
      )}
      <Card>
        <div className="space-y-6">
          {Array.from({ length: fields }, (_, i) => (
            <div key={i} className="space-y-2">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-10 w-full rounded-[var(--radius)]" />
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
